import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Menu from "./components/Menu";
import OrderOnline from "./components/OrderOnline";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PromoModal from "./components/PromoModal";

/* ---------- Error Boundary ---------- */

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-beige px-6">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-display font-bold text-black mb-3">
              Something went wrong
            </h2>
            <p className="text-gray-600 mb-6">
              We're sorry — please refresh the page or try again later.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-redAccent text-white rounded-full font-semibold hover:bg-redDark transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/* ---------- App ---------- */

function App() {
  return (
    <ErrorBoundary>
      <div className="bg-beige font-sans">
        <PromoModal />
        {/* Skip to content link for accessibility */}
        <a
          href="#about"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[999] focus:px-4 focus:py-2 focus:bg-redAccent focus:text-white focus:rounded-md"
        >
          Skip to content
        </a>
        <Navbar />
        <main>
          <Hero />
          <About />
          <Menu />
          <OrderOnline />
          <Gallery />
          <Contact />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
